export interface JobClassAmount {
  JobClassId: number;
  JobClassName: string;
  Amount: number;
  VPJobID: string;
}
